import localforage from "localforage"; // Add this import
import { Modal, Button, Form, Input } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";

export default function LocationModal({
  showChangeLocationModal,
  setShowChangeLocationModal,
  form1,
  currentLocation,
  currentRadius,
  requestLocation,
  fetchNearbyBusinesses,
  setCurrentRadius, // Add this prop
  tempLocation, // Add this prop
  setCurrentLocation, // Add this prop
  setSearchValue
}) {
  return (
    <Modal
      visible={showChangeLocationModal}
      onCancel={() => setShowChangeLocationModal(false)}
      footer={null}
      title="Change location"
    >
      <Form
        form={form1}
        onFinish={() => {
          setShowChangeLocationModal(false);
        }}
        layout="vertical"
      >
        <Form.Item label="Current address" name="currentAddress">
          <Input.TextArea
            defaultValue={currentLocation?.address}
            disabled
            autoSize={{ minRows: 2 }} // Adjust the number of rows as needed
          />
        </Form.Item>
        <Form.Item label="Radius" name="radius">
          <Input type="number" defaultValue={currentRadius} min="2" />
        </Form.Item>
        <div>
          <Button
            type="dashed"
            icon={<EnvironmentOutlined />}
            onClick={() => requestLocation(false)}
            style={{ width: "100%", marginBottom: "16px" }}
          >
            Use current location
          </Button>
        </div>
        <Button
          onClick={() => setShowChangeLocationModal(false)}
          type="default"
          style={{ marginRight: 8 }}
        >
          Cancel
        </Button>
        <Button
          onClick={async () => {
            const updatedRadius =
              form1.getFieldValue("radius") != undefined &&
              currentRadius != Number(form1.getFieldValue("radius"));
            if (updatedRadius) {
              await localforage.setItem(
                "radius",
                Number(form1.getFieldValue("radius"))
              );
              setCurrentRadius(Number(form1.getFieldValue("radius")));
            }
            if (tempLocation) {
              setCurrentLocation(tempLocation);
              await localforage.setItem("LocationDetails", tempLocation);
            }
            fetchNearbyBusinesses(tempLocation || currentLocation);
            setSearchValue("")
          }}
          type="primary"
          htmlType="submit"
        >
          Update
        </Button>
      </Form>
    </Modal>
  );
}
